module.exports = __webpack_public_path__ + "img/tx_raid_coin_mega.f19fc59e.png";